export { create } from "./methods/create.js";
export { insert, insertBatch, insertWithHooks } from "./methods/insert.js";
export { load } from "./methods/load.js";
export { remove } from "./methods/remove.js";
export { save } from "./methods/save.js";
export { search } from "./methods/search.js";
export { getByID, count } from "./methods/docs.js";

export * from "./types/index.js";
export type { Language } from "./tokenizer/languages.js";
export type { InsertConfig, InsertBatchConfig } from "./methods/insert.js";
export type { RetrievedDoc, SearchParams, SearchResult } from "./methods/search.js";
export type { Stemmer, TokenizerConfig, Tokenizer } from "./tokenizer/index.js";
